import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import FloatingLabelInput from "./FloatingLabelInput"

import Select from "react-select"
import TravelDestinationPlan from "./TravelDestinationPlan"
import Fab from "@material-ui/core/Fab"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeTravelDestination extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  travel_destination_id: "",
                  travel_destination_name: "",
                  travel_destination_priority: "",
                  travel_destination_desc: "",
                  optionTravelPlan: [],
                  selectedTravelPlan: "",

                  orderBy: "travel_destination_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newTravelDestination: true,
                  travelDestinationPlan: [],
                  selectedTravelDestinationPlan: "",
            }
      }

      handleTravelDestinationPlan = (selectedTravelDestinationPlan) => {
            this.setState({ selectedTravelDestinationPlan: selectedTravelDestinationPlan })
      }

      handleChangeTravelDestinationName = (event) => {
            this.setState({ travel_destination_name: event.target.value })
      }
      handleChangeTravelDestinationPeriority = (event) => {
            this.setState({ travel_destination_priority: event })
      }
      handleChangeTravelDestinationDesc = (event) => {
            this.setState({ travel_destination_desc: event.target.value })
      }

      handleLevelof_prosperity = (selectedTravelPlan) => {
            this.setState({ selectedTravelPlan: selectedTravelPlan }, () => {})
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        travel_destination_id: row2.travel_destination_id,
                        travel_destination_name: row2.travel_destination_name,
                        travel_destination_priority: row2.travel_destination_priority,
                        travel_destination_desc: row2.travel_destination_desc,
                        selectedTravelPlan: { value: row2.travel_destination_travel_plan_id, label: row2.travel_plan_name },

                        newTravelDestination: false,
                  },
                  () => {
                        this.getoptionTravelDestinationPlan()
                        this.getTravelDestinationPlan(row2.travel_destination_id)
                  }
            )
      }

      getTravelDestinationPlan(travel_destination_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ travelDestinationPlan: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_destinationplan")
            fd.append("travel_destination_id", travel_destination_id)

            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionTravelDestinationPlan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_plan_id, label: arr.data[k].travel_plan_name })
                              }
                              self.setState({ optionTravelDestinationPlan: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_plan")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      saveNewPriceTravelDestinationPlan = () => {
            const { travel_destination_id, selectedTravelDestinationPlan } = this.state
            if (selectedTravelDestinationPlan != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedTravelDestinationPlan: "" })
                                    self.getTravelDestinationPlan(travel_destination_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_travel_destinationplan")
                  fd.append("travel_destinationplan_travel_destination_id", travel_destination_id)
                  fd.append("travel_destinationplan_travel_plan_id", selectedTravelDestinationPlan.value)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      newTravelDestination = (event) => {
            this.setState({
                  travel_destination_id: "",
                  travel_destination_name: "",
                  travel_destination_priority: "",
                  travel_destination_desc: "",
                  selectedTravelPlan: {},
                  newTravelDestination: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getTravelDestination()
                                    self.getoptionTravelPlan()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionTravelPlan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].travel_plan_id, label: arr.data[k].travel_plan_name })
                              }
                              self.setState({ optionTravelPlan: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_plan")
            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.send(fd)
      }

      getTravelDestination() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_travel_destination")

            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewTravelDestination = () => {
            const { travel_destination_priority, selectedTravelPlan, travel_destination_name, travel_destination_desc } = this.state
            if (travel_destination_priority != "" && travel_destination_name != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getTravelDestination()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_travel_destination")
                  fd.append("travel_destination_priority", travel_destination_priority)
                  fd.append("travel_destination_name", travel_destination_name)
                  fd.append("travel_destination_desc", travel_destination_desc)
                  fd.append("travel_destination_travel_plan_id", selectedTravelPlan.value)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مقصد  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      deleteTravelDestination = () => {
            const { travel_destination_id } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              self.newTravelDestination()
                              self.getTravelDestination()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_travel_destination")
            fd.append("travel_destination_id", travel_destination_id)

            xhttp.open("POST", `${constants.BASE_URL}/travel`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeTravelDestination = () => {
            const {
                  travel_destination_id,
                  selectedTravelPlan,
                  travel_destination_name,
                  travel_destination_priority,
                  travel_destination_desc,
            } = this.state
            if (travel_destination_id != "" && travel_destination_name != "" && travel_destination_priority != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getTravelDestination()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_travel_destination")
                  fd.append("travel_destination_id", travel_destination_id)
                  fd.append("travel_destination_name", travel_destination_name)
                  fd.append("travel_destination_priority", travel_destination_priority)
                  fd.append("travel_destination_desc", travel_destination_desc)
                  fd.append("travel_destination_travel_plan_id", selectedTravelPlan.value)

                  xhttp.open("POST", `${constants.BASE_URL}/travel`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مقصد  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      render() {
            const { classes } = this.props
            const {
                  selectedTravelDestinationPlan,
                  optionTravelDestinationPlan,
                  travelDestinationPlan,
                  optionTravelPlan,
                  selectedTravelPlan,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newTravelDestination,
                  travel_destination_id,
                  travel_destination_name,
                  travel_destination_priority,
                  travel_destination_desc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}></Grid>

                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی مقصد " + travel_destination_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="مقصد "
                                                                        handleInputt={this.handleChangeTravelDestinationName}
                                                                        value={travel_destination_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="اولیت نمایش"
                                                                        handleInputt={this.handleChangeTravelDestinationPeriority}
                                                                        value={travel_destination_priority}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات مقصد "
                                                                        handleInputt={this.handleChangeTravelDestinationDesc}
                                                                        value={travel_destination_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">{"طرح مسافرتی"} </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"طرح مسافرتی"}
                                                                              value={selectedTravelPlan}
                                                                              onChange={this.handleLevelof_prosperity}
                                                                              options={optionTravelPlan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <Container>
                                                                        <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                                              {newTravelDestination ? null : (
                                                                                    <Grid container spacing={3}>
                                                                                          {travelDestinationPlan.map(
                                                                                                (travelDestinationPlan, index) => (
                                                                                                      <TravelDestinationPlan
                                                                                                            travelDestinationPlan={
                                                                                                                  travelDestinationPlan
                                                                                                            }
                                                                                                            props={this.props}
                                                                                                            key={index}
                                                                                                      />
                                                                                                )
                                                                                          )}
                                                                                    </Grid>
                                                                              )}
                                                                        </Paper>

                                                                        <Paper className={classes.root}>
                                                                              {newTravelDestination ? null : (
                                                                                    <Grid item xs={12}>
                                                                                          <Grid container spacing={3}>
                                                                                                <Grid item xs={5}>
                                                                                                      <div>
                                                                                                            <label className="on"> استثتاعات </label>
                                                                                                            <Select
                                                                                                                  isSearchable={true}
                                                                                                                  className="adapter-txtsize"
                                                                                                                  placeholder={"استثتاعات"}
                                                                                                                  value={
                                                                                                                        selectedTravelDestinationPlan
                                                                                                                  }
                                                                                                                  onChange={
                                                                                                                        this
                                                                                                                              .handleTravelDestinationPlan
                                                                                                                  }
                                                                                                                  options={
                                                                                                                        optionTravelDestinationPlan
                                                                                                                  }
                                                                                                            />
                                                                                                      </div>
                                                                                                </Grid>

                                                                                                <Grid item item xs={3}>
                                                                                                      <div
                                                                                                            style={{
                                                                                                                  width: "100%",
                                                                                                                  textAlign: "left",
                                                                                                            }}
                                                                                                      >
                                                                                                            <Fab
                                                                                                                  className={classes.small}
                                                                                                                  color="primary"
                                                                                                                  aria-label="add"
                                                                                                                  onClick={
                                                                                                                        this
                                                                                                                              .saveNewPriceTravelDestinationPlan
                                                                                                                  }
                                                                                                            >
                                                                                                                  <AddIcon />
                                                                                                            </Fab>
                                                                                                      </div>
                                                                                                </Grid>
                                                                                          </Grid>
                                                                                    </Grid>
                                                                              )}
                                                                        </Paper>
                                                                  </Container>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newTravelDestination ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.saveNewTravelDestination()
                                                                              }}
                                                                        >
                                                                              {"ثبت مقصد  جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newTravelDestination}
                                                                              >
                                                                                    {"مقصد  جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.changeTravelDestination()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deleteTravelDestination()
                                                                                    }}
                                                                              >
                                                                                    {"حذف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"travel_destination_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "travel_destination_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {"آیدی مقصد  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_destination_id"}
                                                                                          direction={
                                                                                                orderBy === "travel_destination_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_destination_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_destination_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مقصد  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_destination_name"}
                                                                                          direction={
                                                                                                orderBy === "travel_destination_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_destination_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_destination_travel_plan_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"طرح مسافرتی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_destination_travel_plan_id"}
                                                                                          direction={
                                                                                                orderBy === "travel_destination_travel_plan_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "travel_destination_travel_plan_id"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"travel_destination_priority"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"اولویت نمایش"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "travel_destination_priority"}
                                                                                          direction={
                                                                                                orderBy === "travel_destination_priority"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("travel_destination_priority")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["travel_destination_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"travel_destination_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_destination_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"travel_destination_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_destination_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"travel_plan_name"} align={"center"}>
                                                                                                      {row["travel_plan_name"]}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                      key={"travel_destination_priority"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["travel_destination_priority"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeTravelDestination)
